import DateUtils from "../../../util/dateUtils";
export default class CourseSectionMeetingService {
    static fromJSON(json) {
        // @ts-expect-error - TS2322 - Type '{ meetingStartDate: Date; meetingEndDate: Date; id?: number | null | undefined; building?: { id: number; } | undefined; isCancelled?: boolean | undefined; isHoliday?: boolean | undefined; location?: LocationDto | undefined; meetingType?: string | undefined; room?: string | undefined; sourceScheduleElement?: { ...; }...' is not assignable to type 'CourseSectionMeeting'.
        return Object.assign(Object.assign({}, json), { 
            // @ts-expect-error - TS2769 - No overload matches this call.
            meetingStartDate: new Date(json.meetingStartDate), 
            // @ts-expect-error - TS2769 - No overload matches this call.
            meetingEndDate: new Date(json.meetingEndDate) });
    }
    static display(meeting) {
        return (DateUtils.dateTime(meeting.meetingStartDate) +
            " - " +
            meeting.meetingType +
            (meeting.isCancelled ? " - CANCELLED" : "") +
            (meeting.isHoliday ? " - HOLIDAY" : ""));
    }
    static getIdentifiers(meeting) {
        return {
            sourceScheduleElementId: meeting.sourceScheduleElement.id,
            meetingStartDate: meeting.meetingStartDate,
        };
    }
}
